import { CaptionLinkTypography } from '../../../../atoms';
import { Button } from '../../button';

type NoDataLinkProps = React.PropsWithChildren<{
	href: string;
}>;

export const NoDataLink: React.FC<NoDataLinkProps> = ({ children, href }) => {
	return (
		<Button variant="hyperlink" size="xs" className="text-primary" asChild data-testid="no-data-link">
			<a href={href} target="_blank" rel="noreferrer">
				<CaptionLinkTypography className="text-[1rem] text-primary">{children}</CaptionLinkTypography>
			</a>
		</Button>
	);
};
